module.exports = __webpack_public_path__ + "images/Hompage_future_talent.png?cf4e14d";


//////////////////
// WEBPACK FOOTER
// ./assets/component/index/images/Hompage_future_talent.png
// module id = 335
// module chunks = 0